function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M268,289h-43.1c-29.5,0-43.3-14.5-55.5-27.2c-1.7-1.8-3.3-3.5-5-5.2l-71.7-71.7c-18.5-18.5-17.3-40.2,3.6-61 l51.6-51.3c0.6-0.6,1.4-1,2.2-1.2c0.7-0.2,7.1-1.3,12.4,2.5c2.4,1.8,5.4,5.2,6,11.7c0.6,6,2.4,14.3,7.9,19.7 c10.8,10.8,35.6,6.3,44.3,3.6c1.5-0.5,3.2-0.1,4.4,1.1c11.7,11.7,10.4,23.8,8.5,42.2c-0.9,8.6-2,19.4-2,32.6 c0,23.4,14.2,31.8,29.2,40.8c14,8.4,28.6,17,28.6,37.9C289.1,275.2,279.9,289,268,289z M152.9,79.7l-50.5,50.2 c-17.6,17.6-18.7,33.5-3.6,48.7l71.7,71.7c1.7,1.7,3.5,3.5,5.2,5.3c12.1,12.6,23.4,24.5,49.2,24.5H268c6.4,0,12.4-9.5,12.4-16.8 c0-15.9-11.3-22.6-24.3-30.4c-15.7-9.3-33.5-19.9-33.5-48.3c0-13.6,1.2-24.6,2.1-33.5c1.7-16.3,2.6-25.1-4.3-33.3 c-8.7,2.2-36.1,7.7-50.3-6.5c-5.8-5.8-9.3-14.2-10.4-25c-0.3-2.7-1.1-4.5-2.5-5.6C155.9,79.9,154.1,79.7,152.9,79.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M282.4,263.8h-57.3c-13.5,0-28.4-17.4-42.9-34.2c-2.2-2.5-4.2-4.9-6.2-7.2c-13.5-15.4-59.6-68.9-78.8-91.2 l-1.3-1.5c-1.6-1.8-1.4-4.6,0.4-6.1c0.9-0.8,2.1-1.2,3.2-1.1c1.2,0.1,2.3,0.6,3,1.5c0.5,0.6,63.9,74.3,80,92.6 c2,2.3,4.1,4.7,6.3,7.2c11.3,13.2,26.8,31.2,36.2,31.2h57.3c2.4,0,4.4,1.9,4.4,4.4C286.7,261.8,284.8,263.8,282.4,263.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M227,189.2h-25.2c-2.4,0-4.4-1.9-4.4-4.4c0-2.4,1.9-4.4,4.4-4.4H227c2.4,0,4.4,2,4.4,4.4 C231.4,187.1,229.4,189.2,227,189.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M227.9,168.1h-26.1c-2.4,0-4.4-2-4.4-4.4s1.9-4.4,4.4-4.4h26.1c2.4,0,4.4,2,4.4,4.4S230.3,168.1,227.9,168.1 z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M229.9,147.1h-28.1c-2.4,0-4.4-2-4.4-4.4s1.9-4.4,4.4-4.4h28.1c2.4,0,4.4,2,4.4,4.4S232.3,147.1,229.9,147.1 z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M126.6,162.9c-0.7,0-1.4-0.2-2.1-0.5l-0.1,0c-1-0.6-1.8-1.6-2.1-2.7c-0.3-1.1-0.1-2.4,0.5-3.4 c0.2-0.3,4.8-8,6.8-18c1.2-5.9,1.2-11.5,0.2-16.5c-1.3-6.2-4.3-11.7-9-16.4c-1.7-1.7-1.7-4.4-0.1-6.1c0.8-0.8,2-1.4,3.1-1.4 c1.1,0,2.3,0.4,3.2,1.2c5.9,5.9,9.7,12.9,11.4,20.8c1.3,6.2,1.2,13-0.2,20c-2.4,11.9-7.9,20.9-8,21 C129.5,162.2,128,162.9,126.6,162.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M159.2,289H83.9c-2.4,0-4.4-1.9-4.4-4.4c0-2.4,2-4.4,4.4-4.4h75.3c2.4,0,4.4,1.9,4.4,4.4 C163.6,287,161.6,289,159.2,289z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M125.8,263.9H83.9c-2.4,0-4.4-1.9-4.4-4.4s2-4.4,4.4-4.4h41.8c2.4,0,4.4,1.9,4.4,4.4 C130.1,261.9,128.2,263.9,125.8,263.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M100.7,238.8H83.9c-2.4,0-4.4-1.9-4.4-4.4c0-2.4,2-4.4,4.4-4.4h16.7c2.4,0,4.4,1.9,4.4,4.4 C105,236.8,103.1,238.8,100.7,238.8z"
}))));

function SvgGearUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearUp);
export default __webpack_public_path__ + "static/media/GearUp.ef64f1bf.svg";
export { ForwardRef as ReactComponent };